<template>
  <div class="page-container">
    <el-breadcrumb separator="/" class="page-breadcrumb">
      <el-breadcrumb-item>
        客服群二维码设置
      </el-breadcrumb-item>
    </el-breadcrumb>
    <el-card shadow="never" class="page-content">
      微信客服群二维码
      <qr-code-item type="wechat" />
      <hr />
      QQ客服群二维码
      <qr-code-item type="qq" />
    </el-card>
  </div>
</template>

<script>
import './store';
import QrCodeItem from './components/QrCodeItem';

export default {
  name: 'AppSetting',
  components: {
    QrCodeItem
  }
};
</script>

<style lang="less" scoped></style>
